var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSubscription({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.43,21a.6.6,0,0,1-.19.83,5.45,5.45,0,0,1-2.88.87,4.63,4.63,0,0,1-2.12-.51,5.28,5.28,0,0,1-2.72-4.46,8.05,8.05,0,0,1,.85-4,13.67,13.67,0,0,1,2.75-3.62H7.88a.6.6,0,0,1-.6-.6.6.6,0,0,1,.6-.6h3.64a1.65,1.65,0,0,1,1.65,1.65v3.63a.6.6,0,0,1-1.2,0V11a12.74,12.74,0,0,0-2.53,3.32,6.81,6.81,0,0,0-.72,3.36,4.08,4.08,0,0,0,2.07,3.47,3.84,3.84,0,0,0,3.82-.31A.59.59,0,0,1,15.43,21Zm6.69-1.19H18.88a13.67,13.67,0,0,0,2.75-3.62,8.05,8.05,0,0,0,.85-4,5.28,5.28,0,0,0-2.72-4.46,5,5,0,0,0-5,.36.6.6,0,0,0-.19.83.59.59,0,0,0,.82.19,3.84,3.84,0,0,1,3.82-.31,4.08,4.08,0,0,1,2.07,3.47,6.81,6.81,0,0,1-.72,3.36A12.32,12.32,0,0,1,18,19V15.76a.6.6,0,1,0-1.2,0v3.63A1.65,1.65,0,0,0,18.48,21h3.64a.6.6,0,0,0,.6-.6A.6.6,0,0,0,22.12,19.84Z",
    fill: "#fff"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    fill: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubscription);
export default __webpack_public_path__ + "static/media/subscription.7fc69b2cc577c7c589a3230265628594.svg";
export { ForwardRef as ReactComponent };